import { ContactsOutlined, EyeOutlined, RollbackOutlined, SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Input, Modal, Space, Table, Tooltip } from "antd";
import moment from "moment";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useStandByReqStore from "stores/standByReqStore";
import humanize from "utils/formate-status";

const StandByTable = ({
  currentUser
}) => {

  let request = useStandByReqStore((state) => state.standByReqs);

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");

  const [clientSearchValue, setClientSearchValue] = useState('');
  const [clientOptions, setClientOptions] = useState([]);
  const [filteredData, setFilteredData] = useState(false)

  useEffect(() => {
    // Get unique client names from requests
    const uniqueClients = [...new Set(request
      .filter(req => req.client?.name)
      .map(req => req.client.name))]
      .sort((a, b) => a.localeCompare(b));
    
    setClientOptions(uniqueClients.map(name => ({ value: name })));
  }, [request]);

  const fuzzyFilter = (query, productSearch, clientProduct) => {
    if (!query || query.length < 2) {
      setFilteredData(false);
      return;
    }
  
    const queryLower = query.toLowerCase();
    const results = request.map(item => {
      let searchText;
      if (productSearch) {
        searchText = `${item?.product?.name} ${item?.product?.barcode}` || "";
      } else if (clientProduct) {
        searchText = `${item?.client_product?.name} ${item?.client_product?.barcode}` || "";
      } else {
        searchText = item?.client?.name || "";
      }
      
      const searchTextLower = searchText.toLowerCase();
      let priority = -1;
      
      // Highest priority: Starts with the search term
      if (searchTextLower.startsWith(queryLower)) {
        priority = 2;
      }
      // Second priority: Any word starts with the search term
      else if (searchTextLower.split(' ').some(word => word.toLowerCase().startsWith(queryLower))) {
        priority = 1;
      }
      // Lowest priority: Contains the search term
      else if (searchTextLower.includes(queryLower)) {
        priority = 0;
      }
  
      return priority >= 0 ? {
        ...item,
        priority
      } : null;
    })
    .filter(Boolean) // Remove null entries
    .sort((a, b) => {
      // First sort by priority
      if (b.priority !== a.priority) {
        return b.priority - a.priority;
      }
      // Then alphabetically by search text
      const aText = productSearch ? a?.product?.name : 
                   clientProduct ? a?.client_product?.name :
                   a?.client?.name || "";
      const bText = productSearch ? b?.product?.name :
                   clientProduct ? b?.client_product?.name :
                   b?.client?.name || "";
      return aText.localeCompare(bText);
    });
  
    setFilteredData(results);
  };








  const showEngineerData = (record) => {
    Modal.info({
      title: "Contact Details",
      content: (
        <div>
          {
            <>
              <p> {record?.requested_by?.name}</p>
              <p>{record?.requested_by?.phone}</p>
              <p>{record?.requested_by?.email}</p>
            </>
          }
        </div>
      ),

      onOk() {},
    });
  };

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
 
    setOpen(false);
  };


  const columns = [
    {
      title: "Client",
      dataIndex: "client",
      render: (req) => req?.name,
      key: 'client',
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <AutoComplete
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0] || clientSearchValue}
              options={clientOptions}
              onSearch={(value) => {
                const searchLower = value.toLowerCase();
                
                // Filter and sort clients by priority
                const filteredOptions = [...new Set(request
                  .filter(req => req.client?.name)
                  .map(req => req.client.name))]
                  .map(name => {
                    const nameLower = name.toLowerCase();
                    let priority = -1;
                    
                    // Highest priority: Starts with search term
                    if (nameLower.startsWith(searchLower)) {
                      priority = 2;
                    }
                    // Second priority: Word starts with search term
                    else if (nameLower.split(' ').some(word => word.toLowerCase().startsWith(searchLower))) {
                      priority = 1;
                    }
                    // Lowest priority: Contains search term
                    else if (nameLower.includes(searchLower)) {
                      priority = 0;
                    }
                    
                    return { name, priority };
                  })
                  .filter(item => item.priority >= 0)
                  .sort((a, b) => {
                    // Sort by priority first
                    if (b.priority !== a.priority) {
                      return b.priority - a.priority;
                    }
                    // Then alphabetically
                    return a.name.localeCompare(b.name);
                  })
                  .map(item => ({ value: item.name }));
    
                setClientOptions(filteredOptions);
                setClientSearchValue(value);
                setSelectedKeys(value ? [value] : []);
              }}
              onSelect={(value) => {
                setClientSearchValue(value);
                setSelectedKeys([value]);
                confirm();
              }}
              onChange={(value) => {
                setClientSearchValue(value);
                setSelectedKeys(value ? [value] : []);
              }}
              placeholder="Search client"
            />
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setClientSearchValue('');
                setSelectedKeys([]);
                setFilteredData(false);
                // Reset client options to full list
                const uniqueClients = [...new Set(request
                  .filter(req => req.client?.name)
                  .map(req => req.client.name))]
                  .sort((a, b) => a.localeCompare(b));
                setClientOptions(uniqueClients.map(name => ({ value: name })));
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        if (!value) return true;
        const clientName = record.client?.name || '';
        const searchValue = value.toLowerCase();
        const recordName = clientName.toLowerCase();
        
        // Prioritize exact matches and starts with
        if (recordName.startsWith(searchValue)) {
          return true;
        }
        
        // Then check for word starts
        if (recordName.split(' ').some(word => word.toLowerCase().startsWith(searchValue))) {
          return true;
        }
        
        // Finally check for contains
        return recordName.includes(searchValue);
      },
    },

    {
      title: "Date",
      dataIndex: "createdAt",
      // render: (req) => req?.name,
      key: "Date",
      render: (_, request) => {
        return moment(request?.createdAt).utc().format("DD-MM-YYYY");
      },
    },

    {
      title: "Product",
      width: "15%",

      render: (req) => {
        const productName = req?.product?.name || 'Product not assigned';
        const productBarcode = req?.product?.barcode ? `(${req.product.barcode})` : "";
        
        return `${productName} ${productBarcode}`;
      },

      key: "Product",


      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {



        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                // confirm();

                fuzzyFilter(selectedKeys[0],true)
              }}
              onBlur={() => {

                fuzzyFilter(selectedKeys[0],true);
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                fuzzyFilter(selectedKeys[0],true);
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });

                setFilteredData(false)
                setSelectedKeys("");
                confirm()
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        return record.name.replace(/[^a-zA-Z]/g, "").toLowerCase().includes(value.replace(/[^a-zA-Z]/g, "").toLowerCase());
      },
    },




    {
      title: "Client Product",
      dataIndex: "client_product",
      width: "15%",
      render: (req) => `${req?.name}  ${req?.barcode? (req.barcode) :"" }`,
      key: "client_product",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {



        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                // confirm();

                fuzzyFilter(selectedKeys[0], false,true)
              }}
              onBlur={() => {

                fuzzyFilter(selectedKeys[0], false,true);
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                fuzzyFilter(selectedKeys[0], false,true);
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });

                setFilteredData(false)
                setSelectedKeys("");
                confirm()
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        return record.name.replace(/[^a-zA-Z]/g, "").toLowerCase().includes(value.replace(/[^a-zA-Z]/g, "").toLowerCase());
      },
    },

    {
      title: "Warehouse",
      dataIndex: "contact",
      width: "10%",
      render: (_, record) => record?.product?.warehouse?.title,
    },

    {
      title: "Requested By",
      dataIndex: "requested_by",
      width: "10%",
      render: (_, record) => (
        <Space>
          <p> {record?.requested_by?.name}</p>
          <ContactsOutlined
            onClick={() => showEngineerData(record)}
            type="primary"
            style={{ marginBottom: "1rem" }}
          />
        </Space>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, request) => {
        return humanize(request.status)
      },
      filters: [
        { text: "Requested", value: "requested" },
        { text: "Processed", value: "processed" },
        { text: "With Client", value: "with_client" },
        { text: "Picked Up", value: "picked-up" },
        { text: "Returned", value: "returned" },
          ],

      onFilter: (value, record) => {

     
        return record?.status?.includes(value)
      }
      ,
    },
{
      title: "Action",
      dataIndex: "",

      key: "action",
      render: (req) => {
        return (
          <Space key={req?._id} size="middle">
            {req.status === 'with_client' && !req.returned_scheduled && (
              <Tooltip title="Return Standby Product">
                <RollbackOutlined
                  key={req._id}
                  onClick={() =>
                    navigate("/standbyRequest/return/" + req?._id, { state: { ...req, returnTask: true } })
                  }
                />
              </Tooltip>
            )}
      
            <EyeOutlined
              hidden={!currentUser.privileges.includes('stand_by_product_management')}
              onClick={() =>
                navigate("/standbyRequest/" + req?._id, { state: req })
              }
            />
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        title="Title"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>

      <Table
        // key={request._id}
        rowKey={"_id"}
        columns={columns}
        pagination={true}
        // expandable={{
        //     expandedRowRender: (templates) => (
        //         <>
        //             {templates.fields.map((field) => {

        //                 return <Tag key={field._id}>{field.name.toUpperCase()}</Tag>;
        //             })}
        //         </>
        //     ),
        //     rowExpandable: (templates) => templates.fields.length > 3,
        // }}
        dataSource={filteredData ? filteredData : request}
      />

    </>
  );
};

export default StandByTable;
